import React from 'react';
import { hasFeature } from '../../state/zustand';
import { useQ88UpdateDataMutation } from '../../graphql';
import { DropdownButton, Menu, MenuItem } from '../ui';
import useEvent from '../hooks/useEvent';
import {
  createLoadingToast,
  handleApolloError,
  handleToastOfScenarioUpdate,
  handleToastOfSyncData,
  updateToastError,
} from './helpers';
import { useSharedNotificationCenter } from '../contexts/NotificationsContext';

export function Q88Updates({
  restoreIntegrationScenario,
}: {
  restoreIntegrationScenario: () => void;
}): JSX.Element | null {
  const { add } = useSharedNotificationCenter();
  const isQ88ToolsFeatureAvailable = hasFeature('q88_tools');
  const [q88UpdateDataMutation] = useQ88UpdateDataMutation();

  const q88UpdateData = useEvent(async () => {
    const toastId = createLoadingToast('Updating Q88 data...');

    try {
      const updateQ88Result = await q88UpdateDataMutation({
        fetchPolicy: 'no-cache',
      });

      if (updateQ88Result.errors && updateQ88Result.errors?.length > 0) {
        throw updateQ88Result.errors;
      }

      const result = updateQ88Result.data?.q88UpdateData;
      if (!result) {
        throw new Error('No data');
      }

      const { syncOrder, updateScenario } = result;

      handleToastOfSyncData('Q88', 'orders', syncOrder, toastId);
      handleToastOfScenarioUpdate('Q88', updateScenario, add, toastId);

      restoreIntegrationScenario();
    } catch (error) {
      updateToastError(toastId, 'Failed to update Q88 data');
      handleApolloError(error);
    }
  });

  if (!isQ88ToolsFeatureAvailable) return null;
  return (
    <DropdownButton variant="dark" label="Q88 tools" mr={3}>
      <Menu hasShadow>
        <MenuItem label="Q88 Update data" onPress={q88UpdateData} />
      </Menu>
    </DropdownButton>
  );
}
